import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { colorFromMode } from '../../helpers';

/**
* -Polygon-
* Polygon component
**/
export default class Polygon extends React.Component {

	addPolygon = () => {

		const { map, google, path } = this.props;

		// Options
		const options = {
			map,
			strokeColor: colorFromMode(this.props.color),
			strokeOpacity: 0.8,
			strokeWeight: 5,
			fillColor: this.props.fillColor,
			fillOpacity: 0.25,
			path
		};

		this.polygon = new google.maps.Polygon(options);
	}

	componentDidMount() {

		this.addPolygon();
	}

	componentWillUnmount() {

		if (this.polygon) {
			this.polygon.setMap(null);
		}
	}

	render() {
		return null;
	}
}

Polygon.propTypes = {
	path: PropTypes.array.isRequired,
	color: PropTypes.string,
	fillColor: PropTypes.string,
}

Polygon.defaultProps = {
	color: 'random',
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/Polygon.js